module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-4.fd74cd81.jpg";